export default __webpack_public_path__ + "static/media/flag-bonaire.fbae2e80.svg";